/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaCardContent/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Children from 'Simple/Children'
import React from 'react'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function TysiaCardContent({
  children,
  viewPath = "/DesignSystem/TysiaCard/TysiaCardContent",
  flexDirection = "row",
  backgroundColor,
  paddingTop,
  paddingRight,
  paddingBottom,
  paddingLeft,
  overflowX,
  overflowY,
  alignItems = "unset",
  justifyContent = "unset",
  borderBottomLeftRadius,
  borderBottomRightRadius,
  borderTopLeftRadius,
  borderTopRightRadius,
  flexDirectionOverride
  
}) {
  let isMedia = useIsMedia()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let paddingTopOrdtSpaceS = paddingTop ?? dtSpaceS
let paddingRightOrdtSpaceM = paddingRight ?? dtSpaceM
let paddingBottomOrdtSpaceM = paddingBottom ?? dtSpaceM
let paddingLeftOrdtSpaceM = paddingLeft ?? dtSpaceM
let borderBottomLeftRadiusOrdtSpaceXs = borderBottomLeftRadius ?? dtSpaceXs
let borderBottomRightRadiusOrdtSpaceXs = borderBottomRightRadius ?? dtSpaceXs
let borderTopLeftRadiusOrdtSpaceXs = borderTopLeftRadius ?? dtSpaceXs
let borderTopRightRadiusOrdtSpaceXs = borderTopRightRadius ?? dtSpaceXs
  return (<React.Fragment
>
<div
  data-testid="TysiaCardContent.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-2-2cR8rt': backgroundColor,'--pt-3-2cR8rt': typeof paddingTopOrdtSpaceS === 'number' ? `${paddingTopOrdtSpaceS}px` : paddingTopOrdtSpaceS,'--pr-4-2cR8rt': typeof paddingRightOrdtSpaceM === 'number' ? `${paddingRightOrdtSpaceM}px` : paddingRightOrdtSpaceM,'--pb-5-2cR8rt': typeof paddingBottomOrdtSpaceM === 'number' ? `${paddingBottomOrdtSpaceM}px` : paddingBottomOrdtSpaceM,'--pl-6-2cR8rt': typeof paddingLeftOrdtSpaceM === 'number' ? `${paddingLeftOrdtSpaceM}px` : paddingLeftOrdtSpaceM,'--ox-7-2cR8rt': overflowX,'--oy-8-2cR8rt': overflowY,'--ai-9-2cR8rt': alignItems,'--jc-10-2cR8rt': justifyContent,'--bblr-11-2cR8rt': typeof borderBottomLeftRadiusOrdtSpaceXs === 'number' ? `${borderBottomLeftRadiusOrdtSpaceXs}px` : borderBottomLeftRadiusOrdtSpaceXs,'--bbrr-12-2cR8rt': typeof borderBottomRightRadiusOrdtSpaceXs === 'number' ? `${borderBottomRightRadiusOrdtSpaceXs}px` : borderBottomRightRadiusOrdtSpaceXs,'--btlr-13-2cR8rt': typeof borderTopLeftRadiusOrdtSpaceXs === 'number' ? `${borderTopLeftRadiusOrdtSpaceXs}px` : borderTopLeftRadiusOrdtSpaceXs,'--btrr-14-2cR8rt': typeof borderTopRightRadiusOrdtSpaceXs === 'number' ? `${borderTopRightRadiusOrdtSpaceXs}px` : borderTopRightRadiusOrdtSpaceXs,'--fd-1-2cR8rt': isMedia.mobile && !flexDirectionOverride ? "column" : flexDirection}}
 className={`views-block ${styles.Horizontal}`}
>
<Children
  viewPath={`${viewPath}/Children`}
>
{children}
</Children>
</div>
</React.Fragment>)
}